module.exports = __webpack_public_path__ + "static/media/Icon_menu_repair_white.9a5bcb1d.svg";